import React from 'react';
import { Modal, Button } from 'antd';
import OrderConfirmModalFooter from '../confirm-modal/OrderConfirmModalFooter';

export default function OrderCompleteConfirmModal({
  open,
  onCancel,
  onConfirmYes,
  onConfirmNo,
  onMoveBack,
  order,
  loading,
}) {
  return (
    <Modal
      title="Complete order"
      className="order-confirm-modal"
      width={480}
      open={!!open}
      onCancel={onCancel}
      footer={(
        <OrderConfirmModalFooter>
          <Button
            type="primary"
            onClick={onConfirmYes}
            loading={loading}
            className="app-btn-primary"
          >
            Yes, send to completed
          </Button>
          <Button
            onClick={onConfirmNo}
            loading={loading}
            className="app-btn-cancel"
          >
            No, keep as dispatch
          </Button>
          <Button onClick={onMoveBack} loading={loading} className="app-btn-cancel">
            Move back to Ready
          </Button>
        </OrderConfirmModalFooter>
      )}
      destroyOnClose
    >
      {order && (
        <>
          Are you sure you want to send this order to completed?
          {order.orderNumber && (
            <> (Order <strong>{order.orderNumber}</strong>)</>
          )}
        </>
      )}
    </Modal>
  );
}
